import { useInView } from '@/hooks/useInView';
import { useCountUp } from '@/hooks/useCountUp';
import { SOCIAL_PROOF_STATS } from '@/data/content';

function StatItem({
  value,
  suffix,
  prefix,
  label,
  shouldAnimate,
}: {
  value: number;
  suffix: string;
  prefix: string;
  label: string;
  shouldAnimate: boolean;
}) {
  const count = useCountUp(value, 2000, shouldAnimate);

  const display = Number.isInteger(value)
    ? Math.round(count)
    : count.toFixed(1);

  return (
    <div className="flex flex-col items-center gap-1 py-4">
      <span className="text-3xl font-bold text-brand-500 md:text-4xl">
        {prefix}
        {display}
        {suffix}
      </span>
      <span className="text-sm text-gray-400">{label}</span>
    </div>
  );
}

export function SocialProof() {
  const [ref, isInView] = useInView<HTMLElement>();

  return (
    <section ref={ref} className="bg-[#1E293B] py-16">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          {SOCIAL_PROOF_STATS.map((stat) => (
            <StatItem
              key={stat.label}
              value={stat.value}
              suffix={stat.suffix}
              prefix={stat.prefix}
              label={stat.label}
              shouldAnimate={isInView}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
